var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { DataFormField } from '@tencent/data-schema/lib/vue-ui/DataForm';
import { cloneDeep, isEqual, keyBy, maxBy } from "lodash-es";
import { DataStub } from '@tencent/data-schema-core';
import { joinPath } from '@tencent/data-schema/lib/utils/path';
import { $chrootContext, $formContext } from '@tencent/data-schema/lib/vue-ui/definitions';
import { BindingInputMode, BooleanInputMode, DefaultInputMode, InteropableInputMode, JsInputMode } from "../../../../../lib/comps/PropPanel/PropPanel/ParamItem/ParamInputMode";
import "./index.css";
import { INJECT_UICORE_DESIGNER } from "../../../../../lib/utils/consts";
import { getVNodeFromProp } from "../../../../../lib/comps/PropPanel/PropPanel/ParamItem/util";
import { ParamContextProvide } from "../../../../../lib/comps/PropPanel/PropPanel/ParamItem/const";
/**
 * 内置的输入模式
 * 问题: 钩子为什么写在组件外面?
 * mode可以传入组件实例,也可以传入已经有的公共组件,走公共组件的话额外的钩子就尽量不去改公共组件,直接写在外面
 *
 * */
const InternalMode = [BindingInputMode, JsInputMode, InteropableInputMode, DefaultInputMode, BooleanInputMode];
let ParamItem = class ParamItem extends Vue {
  constructor() {
    super(...arguments);
    this.selectedModeIdInternal = '';
    // 退出mode的时候可以临时卸载组件
    this.showInputComponent = true;
    this.dropDownVisible = false;
  }
  get pathParts() {
    return this.path.split('/');
  }
  get pathString() {
    return joinPath(this.pathParts);
  }
  get formContext() {
    // 会持有DataForm[fcWrapper]的响应式依赖
    return this[$formContext]();
  }
  get chrootContext() {
    var _this$$chrootContext;
    return (_this$$chrootContext = this[$chrootContext]) === null || _this$$chrootContext === void 0 ? void 0 : _this$$chrootContext.call(this);
  }
  get root() {
    return this.formContext.rootStub;
  }
  get stub() {
    var _this$chrootContext;
    const parent = ((_this$chrootContext = this.chrootContext) === null || _this$chrootContext === void 0 ? void 0 : _this$chrootContext.stub) || this.root;
    return parent.getStubAtPath(this.pathParts);
  }
  get schema() {
    var _this$stub;
    return (_this$stub = this.stub) === null || _this$stub === void 0 ? void 0 : _this$stub.schema;
  }
  getInputComponent() {
    var _this$$refs;
    // 不是响应式的
    return (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.dataFormField) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.theComponent;
  }
  get selectedModeId() {
    return this.selectedModeIdInternal;
  }
  /** mode的id 因为提供了拦截模式变更功能所以使用setter*/
  set selectedModeId(newValue) {
    if (newValue !== this.selectedModeId) {
      this.checkAndSetMode(newValue);
    }
  }
  async checkAndSetMode(newValue) {
    var _this$modeListLUT$thi, _this$modeListLUT$new, _this$modeListLUT$new2;
    const onExitMode = (_this$modeListLUT$thi = this.modeListLUT[this.selectedModeId]) === null || _this$modeListLUT$thi === void 0 ? void 0 : _this$modeListLUT$thi.onExitMode;
    const res = await (onExitMode === null || onExitMode === void 0 ? void 0 : onExitMode(this, this.getInputComponent()));
    if (!res && onExitMode) return;
    await ((_this$modeListLUT$new = this.modeListLUT[newValue]) === null || _this$modeListLUT$new === void 0 || (_this$modeListLUT$new2 = _this$modeListLUT$new.onUseMode) === null || _this$modeListLUT$new2 === void 0 ? void 0 : _this$modeListLUT$new2.call(_this$modeListLUT$new, this));
    this.showInputComponent = true;
    this.selectedModeIdInternal = newValue;
    this.dropDownVisible = false;
  }
  /** 检查selectedModeId的有效性并尝试修复 同时处理默认值 */
  checkModeId(newValue) {
    const defaultModeId = this.selectedModeId || this.getDefaultModeId();
    const nowMode = this.modeListLUT[defaultModeId] || this.finalModeList[0];
    // LUT和finalModeList有一致性 不会发生循环
    if (nowMode !== null && nowMode !== void 0 && nowMode.id && nowMode.id !== newValue) {
      // 必须设置为有意义的modeId
      this.selectedModeId = nowMode === null || nowMode === void 0 ? void 0 : nowMode.id;
    }
  }
  /** 在做出有意义的变化时emit事件 */
  modeChange(newVal, oldVal) {
    // 无mode转化无mode忽略
    if (!newVal && !oldVal) return;
    // 无mod转化为有mode 是初始第一次加载 忽略
    if (!oldVal) return;
    // 为了防止性能问题 emit一个返回this的函数
    this.$emit('mode-change', newVal, oldVal, () => this);
  }
  get modeListLUT() {
    return keyBy(this.finalModeList, 'id');
  }
  get finalModeList() {
    const modeListMerged = [];
    const modes = this.modeList || this.paramContext.inputModes || InternalMode;
    modes.filter(mode => {
      const enable = mode.canEnable || (() => true);
      return enable(this);
    }).forEach(mode => {
      var _mode$init;
      if (!mode.init) {
        modeListMerged.unshift(mode);
      }
      // 可以手动调整顺序
      (_mode$init = mode.init) === null || _mode$init === void 0 || _mode$init.call(mode, this, modeListMerged);
    });
    return modeListMerged;
  }
  getDefaultModeId() {
    if (this.defaultModeId) {
      return this.defaultModeId;
    }
    const defaultMode = maxBy(this.finalModeList, m => {
      var _m$getDefaultOrder;
      return ((_m$getDefaultOrder = m.getDefaultOrder) === null || _m$getDefaultOrder === void 0 ? void 0 : _m$getDefaultOrder.call(m, this)) || 0;
    });
    return defaultMode === null || defaultMode === void 0 ? void 0 : defaultMode.id;
  }
  /** 当前选择的Mode实例 */
  get selectedMode() {
    return this.modeListLUT[this.selectedModeId];
  }
  get rawValue() {
    return this.stub.getValue();
  }
  get defaultProp() {
    return this.stub.getDefaultValue({
      ignoreCondition: true,
      includeOptional: true
    });
  }
  get isGhostValue() {
    return typeof this.rawValue === 'undefined';
  }
  get editValue() {
    if (this.isGhostValue) {
      return cloneDeep(this.defaultProp);
    }
    return this.rawValue;
  }
  set editValue(newValue) {
    if (this.isGhostValue) {
      // 同默认值 & 空值 拒绝触发修改逻辑
      if (isEqual(newValue, this.defaultProp) || !newValue) return;
    }
    if (newValue === undefined) {
      // 触发reset逻辑
      if (this.paramContext.resetMode === 'default') {
        newValue = this.stub.getDefaultValue({
          ignoreCondition: true,
          includeOptional: true
        });
      }
    }
    // 直接和间接的修改都传回到这里触发事件
    this.stub.setValue(newValue);
    this.$emit('change', newValue, this);
    // 写入数据实例 触发rawValue修改
  }
  initEditValueDeepWatch(newValue) {
    if (!newValue) {
      var _this$rmEditValueDeep;
      (_this$rmEditValueDeep = this.rmEditValueDeepWatch) === null || _this$rmEditValueDeep === void 0 || _this$rmEditValueDeep.call(this);
      return;
    }
    this.rmEditValueDeepWatch = this.$watch(() => Vue.observable({
      value: this.editValue
    }), ({
      value: newValue
    }) => {
      if (!isEqual(newValue, this.defaultProp)) {
        // 触发setter [[[通知修改事件]]]
        this.editValue = newValue;
      }
    }, {
      deep: true
    });
  }
  /** 判断当前用哪种渲染方式 */
  get useDataFormField() {
    return typeof this.selectedMode.component !== 'function';
  }
  get renderTitle() {
    var _ref;
    const h = this.$createElement;
    const title = (_ref = getVNodeFromProp(this, 'title') || this.schema.title) !== null && _ref !== void 0 ? _ref : this.schema.id;
    const description = getVNodeFromProp(this, 'description') || this.schema.description;
    return [h("div", [title !== null && title !== void 0 ? title : this.schema.id]), description ? h("a-tooltip", [h("pre", {
      "slot": "title",
      "style": "margin: 0; white-space: pre-wrap"
    }, [description]), h("a-icon", {
      "attrs": {
        "type": "info-circle"
      }
    })]) : null];
  }
  async reset() {
    const {
      onReset
    } = this.selectedMode;
    if (onReset) {
      var _this$selectedMode$on, _this$selectedMode;
      const res = await ((_this$selectedMode$on = (_this$selectedMode = this.selectedMode).onReset) === null || _this$selectedMode$on === void 0 ? void 0 : _this$selectedMode$on.call(_this$selectedMode, this, this.getInputComponent()));
      if (res) {
        return;
      }
    }
    this.editValue = undefined;
    this.selectedModeId = this.getDefaultModeId();
  }
  get tooltipOverlayStyle() {
    return {
      visibility: this.designer.skeletonStyle.hidePropPanelTooltip ? 'hidden' : '',
      'pointer-events': 'none'
    };
  }
  get renderReset() {
    const h = this.$createElement;
    if (this.schema['uc:allowReset'] === false) return undefined;
    return this.allowReset ? h("a-tooltip", {
      "attrs": {
        "title": `重置${this.path}为初始值`,
        "overlayStyle": this.tooltipOverlayStyle
      },
      "class": "uc-paramItem-actionButton",
      "on": {
        "click": this.reset
      }
    }, [h("i", {
      "class": "fa fa-undo",
      "attrs": {
        "aria-hidden": "true"
      }
    })]) : null;
  }
  /** 切换输入mode的下拉菜单 */
  get renderModeDropDown() {
    var _this$selectedMode2, _this$selectedMode2$m;
    const h = this.$createElement;
    const getModeName = mode => {
      var _mode$icon;
      return (mode === null || mode === void 0 || (_mode$icon = mode.icon) === null || _mode$icon === void 0 ? void 0 : _mode$icon.call(mode, this.$createElement)) || mode.name || mode.id;
    };
    const tip = (_this$selectedMode2 = this.selectedMode) === null || _this$selectedMode2 === void 0 || (_this$selectedMode2$m = _this$selectedMode2.modeHint) === null || _this$selectedMode2$m === void 0 ? void 0 : _this$selectedMode2$m.call(_this$selectedMode2, this.$createElement, this);
    const styles = this.dropDownVisible && 'opacity: 1';
    return h("a-dropdown", {
      "style": styles,
      "class": "uc-paramItem-actionButton",
      "model": {
        value: this.dropDownVisible,
        callback: $$v => {
          this.dropDownVisible = $$v;
        }
      }
    }, [h("a", {
      "class": "ant-dropdown-link"
    }, [h("a-tooltip", {
      "class": "uc-propForm-actionButton",
      "style": styles,
      "attrs": {
        "overlayStyle": this.tooltipOverlayStyle
      }
    }, [!!tip ? h("div", {
      "slot": 'title'
    }, [tip]) : null, getModeName(this.selectedMode)]), h("a-icon", {
      "attrs": {
        "type": "down"
      }
    })]), h("a-menu", {
      "slot": "overlay",
      "on": {
        "click": ({
          key
        }) => this.selectedModeId = key
      }
    }, [this.finalModeList.map(mode => h("a-menu-item", {
      "key": mode.id
    }, [getModeName(mode), " ", mode.desc]))])]);
  }
  /** 在只有两种模式时 通过点按切换 */
  get renderModeCheckBox() {
    var _this$selectedMode3, _this$selectedMode3$m;
    const h = this.$createElement;
    const tip = (_this$selectedMode3 = this.selectedMode) === null || _this$selectedMode3 === void 0 || (_this$selectedMode3$m = _this$selectedMode3.modeHint) === null || _this$selectedMode3$m === void 0 ? void 0 : _this$selectedMode3$m.call(_this$selectedMode3, this.$createElement, this);
    const modeIndex = this.finalModeList.findIndex(m => m.id === this.selectedModeId) || 0;
    const getOtherMode = () => this.finalModeList[1 ^ modeIndex];
    const changeMode = () => {
      this.selectedModeId = getOtherMode().id;
    };
    const getModeIcon = mode => {
      var _mode$icon2;
      return mode === null || mode === void 0 || (_mode$icon2 = mode.icon) === null || _mode$icon2 === void 0 ? void 0 : _mode$icon2.call(mode, this.$createElement);
    };
    const renderModeIcon = () => {
      const icon = getModeIcon(this.selectedMode);
      if (icon) {
        return icon;
      }
      const icon2 = getModeIcon(getOtherMode());
      return h("span", {
        "style": 'filter: grayscale(1);'
      }, [icon2]);
    };
    return h("a-tooltip", {
      "class": "uc-paramItem-actionButton",
      "attrs": {
        "overlayStyle": this.tooltipOverlayStyle
      },
      "on": {
        "click": changeMode
      }
    }, [!!tip ? h("div", {
      "slot": 'title'
    }, [tip]) : null, renderModeIcon()]);
  }
  get useModeSlotTitle() {
    return this.selectedMode.place === 'title';
  }
  get ghostStub() {
    const stub = new DataStub({
      schema: this.schema
    });
    stub.setValue(this.defaultProp);
    stub.setValue = value => this.stub.setValue(value);
    return stub;
  }
  renderInputMode(title) {
    var _this$selectedMode4;
    const h = this.$createElement;
    const InputComponent = (_this$selectedMode4 = this.selectedMode) === null || _this$selectedMode4 === void 0 ? void 0 : _this$selectedMode4.component;
    const inputModule = InputComponent ? this.selectedMode : undefined;
    return h("div", {
      "style": this.schema.type === 'boolean' && 'display:flex;gap:4px;margin-bottom:-4px'
    }, [h(DataFormField, {
      "ref": 'dataFormField',
      "attrs": {
        "internalStub": this.isGhostValue ? this.ghostStub : undefined,
        "componentModule": inputModule,
        "path": this.pathString,
        "label": ""
      },
      "class": "uc-propForm-input"
    }), title ? h("div", {
      "slot": "title",
      "class": "uc-propForm-label"
    }, [title]) : null]);
  }
  /**
   * 两种布局模式
   * 1.  input(内含title) rightSlot
   *
   * 2.   title   rightSlot
   *      input
   * */
  render() {
    const h = arguments[0];
    if (!this.selectedMode || !this.showInputComponent) return;
    const rightSlot = h("div", {
      "style": 'display:flex;gap:4px;align-items:center;margin-right:4px'
    }, [this.renderReset, this.finalModeList.length === 2 && this.renderModeCheckBox, this.finalModeList.length >= 3 && this.renderModeDropDown]);
    const title = this.renderTitle;
    const inputMode = this.renderInputMode;
    // 写if else+slot太抽象了 我决定把两种布局列到这
    const defaultPlace = [h("div", {
      "class": "uc-propForm-label"
    }, [title, h("div", {
      "style": "flex: 1"
    }), rightSlot]), inputMode()];
    // 交给用户自定义title 此时title于input中的插槽中渲染
    const titlePlace = h("div", {
      "class": "uc-propForm-label",
      "style": this.schema.type === 'boolean' && 'margin-bottom:0'
    }, [inputMode(title), h("div", {
      "style": "flex: 1"
    }), rightSlot]);
    return h("div", {
      "class": "uc-propForm-item uc-paramItem",
      "on": {
        ...{
          "!dragenter": ev => this.$emit('dragenter', ev, this)
        },
        ...{
          "!dragover": ev => this.$emit('dragover', ev, this)
        },
        ...{
          "!dragleave": ev => this.$emit('dragleave', ev, this)
        },
        ...{
          "!drop": ev => this.$emit('drop', ev, this)
        }
      }
    }, [this.useModeSlotTitle ? titlePlace : defaultPlace]);
  }
};
__decorate([Prop()], ParamItem.prototype, "title", void 0);
__decorate([Prop()], ParamItem.prototype, "description", void 0);
__decorate([Prop()], ParamItem.prototype, "modeList", void 0);
__decorate([Prop()], ParamItem.prototype, "defaultModeId", void 0);
__decorate([Prop({
  default: null
})], ParamItem.prototype, "allowExpr", void 0);
__decorate([Prop({
  default: true
})], ParamItem.prototype, "allowReset", void 0);
__decorate([Prop({
  default: ''
})], ParamItem.prototype, "path", void 0);
__decorate([Inject(ParamContextProvide.context)], ParamItem.prototype, "paramContext", void 0);
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], ParamItem.prototype, "designer", void 0);
__decorate([Watch('selectedModeId', {
  immediate: true
})], ParamItem.prototype, "checkModeId", null);
__decorate([Watch('selectedModeId', {
  immediate: true
})], ParamItem.prototype, "modeChange", null);
__decorate([Watch('isGhostValue', {
  immediate: true
})], ParamItem.prototype, "initEditValueDeepWatch", null);
ParamItem = __decorate([Component({
  name: 'ParamItem',
  inject: {
    [$formContext]: {
      default: null
    },
    [$chrootContext]: {
      default: null
    }
  },
  provide() {
    return {
      ['paramItem']: this
    };
  }
})], ParamItem);
export { ParamItem };
//# sourceMappingURL=ParamItem.js.map
